module.exports = __webpack_public_path__ + "static/media/14.c3b0312f.jpg";